import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import React, { useCallback } from "react";
import { useMutation, useQueryClient } from "react-query";

import { styles } from "./styles";
import { apiService } from "../../../../services";

const OPTIONS = [
  {
    value: "increase",
    label: "Increase is favorable (e.g. Revenue)",
  },
  {
    value: "decrease",
    label: "Decrease is favorable (e.g. Costs)",
  },
];

export const FavorableDirection = ({ favorableDirection, indicatorId }) => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    ({ indicatorId, data }) => apiService.updateIndicator(indicatorId, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["indicator", indicatorId]);
      },
    }
  );

  const onChangeDirection = useCallback(
    (event) => {
      mutate({
        indicatorId,
        data: { favorable_direction: event.target.value },
      });
    },
    [indicatorId, mutate]
  );

  return (
    <Stack mt={2.5} spacing={1}>
      <Typography sx={styles.sectionTitle}>Favorable direction</Typography>
      <FormControl component="fieldset">
        <RadioGroup
          value={favorableDirection || "increase"}
          onChange={onChangeDirection}
          name="favorable-direction"
        >
          {OPTIONS.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio size="small" />}
              label={option.label}
              sx={styles.checkboxWithLabel}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </Stack>
  );
};
